<!--
 * @Descripttion: 
 * @Author: liang
 * @Date: 2020-09-11 17:22:16
 * @LastEditors: liang
 * @LastEditTime: 2021-06-08 09:38:44
-->
<template>
  <div>
    <div class="main">
      <!-- 中部小导航 -->
      <!-- <div id="secondnav">
        <div class="secondnav">
          <div class="title">新闻资讯</div>
          <div class="mbx">
            <el-page-header @back="goBack"></el-page-header>
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item>详情页</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="nav">
            <a
              :class="{ on: item.dictValue == tid }"
              v-for="(item, index) in navlist"
              @click="changetab(item.dictValue)"
              :key="index"
              >{{ item.dictName }}</a
            >
          </div>
        </div>
      </div> -->
      <!-- 中部小导航 end-->
      <!-- <div class="nav">
        <div class="title">新闻资讯</div>
        <a
          :class="{ on: item.dictValue == tid }"
          v-for="(item, index) in navlist"
          @click="changetab(item.dictValue)"
          :key="index"
          >{{ item.dictName }}</a
        >
      </div> -->
      <div class="content" style="width:1200px;box-sizing:border-box">
        <div class="mbx">
          <el-page-header @back="goBack"></el-page-header>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>详情页</el-breadcrumb-item>
          </el-breadcrumb>
          <!-- <el-button
            type="success"
            size="mini"
            plain
            style="position:absolute;right:20px;top:17px"
            @click="download"
            >下载</el-button
          > -->
        </div>
        <div class="article">
          <div class="titlename">
            <h2>
              {{ info.title }}
            </h2>
            <p>
              <span
                >发布时间：{{
                  info.createDate ? info.createDate.split(" ")[0] : ""
                }}</span
              >
            </p>
          </div>
          <div class="nr" v-html="info.content"></div>
          <div class="nr">
            点击下载：
            <el-button type="success" size="mini" plain @click="download">{{
              info.title
            }}</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tid: "",
      id: "0",
      navlist: [],
      info: {}
    };
  },
  watch: {
    $route: {
      handler() {
        this.tid = this.$route.query.tid;
        this.id = this.$route.query.id;
        this.getinfo();
      },
      immediate: true
    }
  },
  methods: {
    getinfo() {
      this.$get("/website/hxservicecenter/" + this.id).then(res => {
        this.info = res.data;
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    download() {
      var url = this.$baseURL + "/website/webSiteDownloadZipFile?id=" + this.id;
      window.open(url);
    }
  }
};
</script>
<style scoped>
.content {
  padding: 0 20px 20px 20px;
}
.article {
  background: #fff;
}
.titlename {
  padding: 30px 0;
  border-bottom: 1px dashed #ccc;
}
.nr {
  padding: 20px 60px;
}
.nr /deep/img {
  max-width: 100%;
}
.titlename h2 {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}
.titlename p {
  text-align: center;
}
.titlename p span {
  padding: 10px 0;
}
/* 中部小导航 */
#secondnav {
  width: 100%;
  background: #fff;
  border-bottom: 1px solid rgb(138, 159, 197);
  box-sizing: border-box;
  height: 80px;
}
.secondnav {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}
.secondnav .title {
  font-weight: bold;
  float: left;
  padding: 0 25px;
  line-height: 75px;
  display: inline-block;
  font-size: 16px;
  border-bottom: 5px solid rgb(30, 69, 141);
  box-sizing: border-box;
}
.secondnav .nav {
  float: right;
  height: 80px;
  display: flex;
  align-items: center;
}
.secondnav .nav a {
  display: inline-block;
  padding: 10px 15px;
  background: rgb(102, 119, 170);
  margin-left: 20px;
  font-size: 16px;
  color: #fff;
}
.secondnav .nav a.on,
.secondnav .nav a:hover {
  background: #9c1f21;
}
.mbx {
  padding: 10px 0;
  position: relative;
}
.el-page-header,
.el-breadcrumb {
  display: inline-block;
}
.el-page-header:hover /deep/ .el-page-header__title {
  color: #409eff;
}
.islinkitem /deep/.el-breadcrumb__inner {
  font-weight: bold;
  cursor: pointer;
  color: #303133;
}
.islinkitem /deep/.el-breadcrumb__inner:hover {
  color: #409eff;
}
</style>
